import { HopperVariablePrefix, HopperColors, DataVizColors, BackgroundColors, TextColors, IconColors, Elevation, FontSize, FontWeight, LineHeight, FontFamily, Shape, CoreSpace, SemanticSimplePaddingSpace, SemanticComplexPaddingSpace, SemanticSimpleMarginSpace, SemanticComplexMarginSpace } from './chunk-PCGVOTW3.js';
import { parseResponsiveValue } from './chunk-SFOVKOPG.js';
import { isNil } from './chunk-U5R6ZXH3.js';

// src/tokens/token-mappings.ts
var ColorExpressionTypes = [
  "#",
  "rgb",
  "rgba",
  "hsl",
  "hsla"
];
var DefaultBorderWidthAndStyle = "1px solid";
function createMapping(mappings, template = createValueTemplate) {
  return Object.entries(mappings).reduce((acc, [key, value]) => {
    acc[key] = template(value);
    return acc;
  }, {});
}
function createValueTemplate(value) {
  return `var(${`${HopperVariablePrefix}-${value}`})`;
}
function createBorderValueTemplate(value) {
  return `${DefaultBorderWidthAndStyle} ${createValueTemplate(value)}`;
}
var ColorMapping = createMapping(HopperColors);
var DataVizColorMapping = createMapping(DataVizColors);
var BackgroundColorMapping = {
  ...createMapping(BackgroundColors),
  ...ColorMapping,
  ...DataVizColorMapping
};
var BorderMapping = {
  ...createMapping(BackgroundColors, createBorderValueTemplate),
  ...createMapping(HopperColors, createBorderValueTemplate),
  ...createMapping(DataVizColors, createBorderValueTemplate)
};
var TextColorMapping = {
  ...createMapping(TextColors),
  ...ColorMapping,
  ...DataVizColorMapping
};
var IconColorMapping = {
  ...createMapping(IconColors),
  ...ColorMapping,
  ...DataVizColorMapping
};
var BoxShadowMapping = createMapping(Elevation);
var FontSizeMapping = createMapping(FontSize);
var FontWeightMapping = createMapping(FontWeight);
var LineHeightMapping = createMapping(LineHeight);
var FontFamilyMapping = createMapping(FontFamily);
var BorderRadiusMapping = createMapping(Shape);
var SpaceMapping = createMapping(CoreSpace);
var SimplePaddingMapping = {
  ...createMapping(SemanticSimplePaddingSpace),
  ...SpaceMapping
};
var ComplexPaddingMapping = {
  ...SimplePaddingMapping,
  ...createMapping(SemanticComplexPaddingSpace)
};
var SimpleMarginMapping = {
  ...createMapping(SemanticSimpleMarginSpace),
  ...SpaceMapping
};
var ComplexMarginMapping = {
  ...SimpleMarginMapping,
  ...createMapping(SemanticComplexMarginSpace)
};
var SizingMapping = {
  ...SpaceMapping
  // TODO: Sizing scale still missing, only core tokens are available at the moment
};
function parseResponsiveSystemValue(value, systemValues, matchedBreakpoints) {
  if (isNil(value)) {
    return value;
  }
  const systemValue = getSystemValue(value, systemValues);
  if (!isNil(systemValue)) {
    return systemValue;
  }
  const underlyingValue = parseResponsiveValue(value, matchedBreakpoints);
  if (!isNil(underlyingValue)) {
    const underlyingSystemValue = getSystemValue(underlyingValue, systemValues);
    if (!isNil(underlyingSystemValue)) {
      return underlyingSystemValue;
    }
  }
  return underlyingValue;
}
function getSystemValue(value, systemValues) {
  return systemValues[value];
}

export { BackgroundColorMapping, BorderMapping, BorderRadiusMapping, BoxShadowMapping, ColorExpressionTypes, ColorMapping, ComplexMarginMapping, ComplexPaddingMapping, DataVizColorMapping, DefaultBorderWidthAndStyle, FontFamilyMapping, FontSizeMapping, FontWeightMapping, IconColorMapping, LineHeightMapping, SimpleMarginMapping, SimplePaddingMapping, SizingMapping, SpaceMapping, TextColorMapping, getSystemValue, parseResponsiveSystemValue };
